import { render, staticRenderFns } from "./RelateTariffSchedule.vue?vue&type=template&id=29fbba04&"
import script from "./RelateTariffSchedule.vue?vue&type=script&lang=js&"
export * from "./RelateTariffSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RelateTariffSchedule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports